import { render } from "./BlogFormView.vue?vue&type=template&id=0896ee54"
import script from "./BlogFormView.vue?vue&type=script&lang=js"
export * from "./BlogFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__